import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

const { AD_APPROVAL_CALLBACK_API_URL } = CONSTANT

// Grafana facts callback is intentionally disabled.
// Previous callback constant wiring from 2341ae3:
// const {
// 	AD_APPROVAL_CALLBACK_API_URL,
// 	AD_GRAFANA_FACTS_CALLBACK_API_URL
// } = CONSTANT

export interface AdGitOpsCallbackResponse {
	ok: boolean
	status: number
	html: string
}

const callCallback = async (
	baseUrl: string,
	queryString: string
): Promise<AdGitOpsCallbackResponse> => {
	const url = `${baseUrl}${queryString || ''}`
	const response = await fetchWithAuthorizationHeader(url, {
		method: 'GET',
		headers: {
			Accept: 'text/html'
		}
	})

	return {
		ok: response.ok,
		status: response.status,
		html: await response.text()
	}
}

export const approveAdGitOpsRequest = (queryString: string) =>
	callCallback(AD_APPROVAL_CALLBACK_API_URL, queryString)

// Previous callback export from 2341ae3:
// export const confirmGrafanaFacts = (queryString: string) =>
// 	callCallback(AD_GRAFANA_FACTS_CALLBACK_API_URL, queryString)
